const STORAGE_KEY = 'falcon-planner:gantt-show-chart';

/** Default: chart visible. */
export function loadShowGanttChartPreference(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (raw === '0' || raw === 'false') return false;
    if (raw === '1' || raw === 'true') return true;
    return true;
  } catch {
    return true;
  }
}

export function saveShowGanttChartPreference(show: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, show ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}
